import { usePage } from '@inertiajs/react';
import { useEffect, useRef } from 'react';

import { LogRocket } from '@/lib/logrocket';
import type { PageProps } from '@/types';

export function useLogRocketIdentify(enabled = true): void {
  const { identity } = usePage<PageProps>().props;
  const identityIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!identity) {
      identityIdRef.current = null;
      return;
    }

    if (identityIdRef.current === identity.id) {
      return;
    }

    LogRocket.identify(identity.id, {
      ...(identity.$display_name && { name: identity.$display_name })
    });

    identityIdRef.current = identity.id;
  }, [enabled, identity]);
}
